import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { ViewTitle } from '../components/reusable'
import { AllocateClaimsView } from '../components/views/allocateClaimsView'

function AllocateClaims() {
    return (
        <div className="allocateClaims">
            <Sidebar />
            <MainView>
                <ViewTitle text={'Allocate Claims'} />
                <AllocateClaimsView />
            </MainView>
        </div>
    )
}

export default AllocateClaims
